import * as React from "react";
import { Category } from "../types";
import useApi from "@/hooks/useApi";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader
} from "@velaro/velaro-component-lib";
import {
  PrimaryBlueButton,
  SecondaryBlueButton
} from "@velaro/velaro-component-lib";

interface Props {
  displayPriority: number;
  onClose(): void;
  onSubmit(category: Category): void;
}

const INPUT_CLASS =
  "w-full px-3 py-2 border border-slate-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent";
const LABEL_CLASS = "block text-sm font-medium text-slate-700 mb-1";

export default function CategoryCreateModal(props: Props) {
  const [saving, setSaving] = React.useState(false);
  const [name, setName] = React.useState("");
  const api = useApi();

  const handleSubmit = React.useCallback(async () => {
    if (!name.trim()) return;
    setSaving(true);
    try {
      const response = await api.admin.post("api/kb/categories", {
        name,
        displayPriority: props.displayPriority
      });
      const json = await response.json();
      props.onSubmit(json);
    } catch (err) {
      console.error("Failed to create category:", err);
    } finally {
      setSaving(false);
    }
  }, [name, props]);

  return (
    <Modal show={true}>
      <ModalHeader title="New Category" onClose={() => props.onClose()} />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <ModalBody>
          <div>
            <label htmlFor="category-name" className={LABEL_CLASS}>Name</label>
            <input
              autoFocus
              id="category-name"
              type="text"
              className={INPUT_CLASS}
              value={name}
              onChange={(e) => setName(e.currentTarget.value)}
            />
            <p className="text-xs text-slate-400 mt-1">
              Top-level grouping that organizes related topics (e.g. "Billing", "Getting Started")
            </p>
          </div>
        </ModalBody>
        <ModalFooter>
          <SecondaryBlueButton
            label="Cancel"
            disabled={saving}
            onClick={() => props.onClose()}
          />
          <PrimaryBlueButton
            label={saving ? "Creating…" : "Create Category"}
            disabled={saving || !name.trim()}
            onClick={() => handleSubmit()}
          />
        </ModalFooter>
      </form>
    </Modal>
  );
}
